import {Button, Datagrid, DateField, FunctionField, TextField} from "react-admin";
import {DatagridPropsWithOptions} from "../../shared/types";
import {initField} from "../../shared/utils";
import {ReconciliationSelectField} from "./ReconciliationSelectField";
import {Typography} from "@material-ui/core";

export const ReconciliationJournalEntryDatagrid = ({
  selectedRow,
  setFileRow,
  setSelectJournalEntry,
  options,
  ...rest
}: DatagridPropsWithOptions & {
  selectedRow: any[];
  setFileRow: React.Dispatch<React.SetStateAction<any[]>>;
  setSelectJournalEntry: React.Dispatch<React.SetStateAction<any[]>>;
}) => {

  return options ? (
    <Datagrid {...rest} style={{ "overflow": "auto" }}>
      <ReconciliationSelectField
        selectedRow={selectedRow}
        setSelectedRow={setSelectJournalEntry}
      />
      <TextField {...initField("description", options)} style={{whiteSpace: "pre-wrap"}}/>
      <DateField {...initField("date", options)} />
      <FunctionField
        label="Importo"
        render={(tableRecord: any | undefined) => {
          if (tableRecord.journal_type === "I") {
            return <Typography style={{ color: "green" }}>+ {tableRecord.amount}</Typography>
          } else {
            return <Typography color="primary">- {tableRecord.amount}</Typography>
          }
        }}
      />
      <FunctionField
        label="Consigliato"
        source="advised"
        render={(tableRecord: any | undefined) => {
          if (!tableRecord || !tableRecord.advised || tableRecord.advised.length <= 0)
            return null;
          return <Button
            label="Consigliato"
            onClick={() =>{ setFileRow(tableRecord.advised); setSelectJournalEntry([tableRecord.id])}}
          />;
        }}
      />
    </Datagrid>
  ) : null;
};